<template>
  <card>
    <h4 slot="header" class="card-title">Yeni Kumbara</h4>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
    >
      <a-form-model-item ref="code" label="Kumbara Kodu" prop="code">
        <a-input
          placeholder="Kumbara Kodu"
          v-model="form.code"
          @blur="() => { $refs.code.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="name" label="Kumbara Adı" prop="name">
        <a-input
          placeholder="Kumbara Adı"
          v-model="form.name"
          @blur="() => { $refs.name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="description" label="Detay" prop="description">
        <a-textarea v-model="form.description" placeholder="Detay" :rows="2" />
      </a-form-model-item>

      <a-form-model-item label="İşletme" prop="corporation_id">
        <a-select
          show-search
          allowClear
          placeholder="İşletme seçiniz"
          v-model="form.corporation_id"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="corp in corporationList"
            :value="corp.id"
            :key="corp.id"
          >
            {{ corp.corporation_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        help="Kaç günde bir boşaltma işlemi yapılması gerektiğini ifade eder."
        ref="unload_interval"
        label="Boşaltma Periyodu"
        prop="unload_interval"
      >
        <a-input-number
          placeholder="Gün"
          v-model="form.unload_interval"
          :min="1"
          :max="365"
        />
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Oluştur
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>

<script>
import Card from 'src/components/Cards/Card.vue'

export default {
  components: { Card },

  mounted() {
    this.$store.dispatch('Corporation/requestCorporationList').then((res) => {
      this.corporations = res.corporations || []
    })
  },

  watch: {
    'form.code'(newVal) {
      this.$emit('codeChange', newVal)
    },
  },

  computed: {
    corporationList() {
      return this.corporations
    },
  },

  data() {
    return {
      corporations: [],
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      form: {
        code: '',
        name: '',
        description: '',
        corporation_id: undefined,
        unload_interval: null,
      },
      rules: {
        code: [
          { required: true, message: 'Kod alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 50, message: 'Kod alanı 2-50 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        name: [
          { required: true, message: 'Kumbara Adı alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 100, message: 'Kumbara Adı 2-100 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        corporation_id: [
          { required: true, message: 'İşletme seçimi zorunludur', trigger: 'change', type: 'number' },
        ],
      },
    }
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },

    onSubmit() {
      const self = this
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return

        self.loading = true
        const payload = {
          code: self.form.code,
          name: self.form.name,
          description: self.form.description,
        }

        self.$store.dispatch('Moneybox/requestMoneyboxCreate', payload).then((moneybox) => {
          const afterCreate = []

          afterCreate.push(
            self.$store.dispatch('Corporation/requestCorporationMoneyboxAssignmentCreate', {
              corporation_id: self.form.corporation_id,
              selected_moneyboxes: [{ key: moneybox.id }],
            })
          )

          if (self.form.unload_interval > 0) {
            afterCreate.push(
              self.$store.dispatch('Moneybox/requestMoneyboxUnloadIntervalCreate', {
                moneybox_id: moneybox.id,
                interval: self.form.unload_interval,
              })
            )
          }

          Promise.all(afterCreate).then(() => {
            self.$notification.success({
              message: 'Kumbara Ekleme',
              description: 'Kumbara başarılı bir şekilde oluşturuldu.',
            })
            self.$router.push('/admin/money-boxes/')
          })
        }).catch(() => {
          self.$notification.error({
            message: 'Kumbara Ekleme',
            description: 'Kumbara eklenirken bir hata oluştu.',
          })
        }).finally(() => {
          self.loading = false
        })
      })
    },

    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>
